import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD4JSaBGpGXpGaLRFgNZgQBklw0HkbYAOo",
  authDomain: "beanbuzz-4efcb.firebaseapp.com",
  projectId: "beanbuzz-4efcb",
  storageBucket: "beanbuzz-4efcb.firebasestorage.app",
  messagingSenderId: "978800699312",
  appId: "1:978800699312:web:8eeadc2ea6b5356d5d1875",
  measurementId: "G-ZR101N283K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Set persistence to local for faster auth state restoration
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set auth persistence:', error);
});

export const analytics = getAnalytics(app);
export default app; 